export default "__VITE_ASSET__BVWVM6$M__$_?url__"